import { Fragment, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { translate } from 'react-switch-lang';
import { Alert, Button, FormGroup, Modal, ModalBody, ModalHeader } from 'reactstrap';
import SweetAlert from 'sweetalert2';
import { useHttpClient } from '../../../../../../security/hooks/axiosProvider';
import styles from '../../../../styles/style-setting.module.scss';

const CreateSousActivity = (props) => {
  const httpClient = useHttpClient(true);
  const {
    register,
    handleSubmit,
    resetField,
    formState: { errors },
  } = useForm();
  const [CreateModal, setCreateModal] = useState(false);
  const [Open, setOpen] = useState(false);
  const [activities, setActivities] = useState([]);
  const CreateModalToggle = () => resetForm();
  const Toggle = () => setOpen(!Open);
  const history = useHistory();
  const [spinner, setSpinner] = useState(false);

  const onSubmit = async (data) => {
    const subActivityData = { name: data['sub_activity_name'], activity: JSON.parse(data['sub_activity_activity']) };
    try {
      setSpinner(true);
      const response = httpClient.current?.post(`/api/subactivity`, subActivityData);
      if ((await response).status === 200) {
        setSpinner(false);
        props.subActivities();
        resetForm();
      }
    } catch (error) {
      SweetAlert.fire({
        icon: 'error',
        title: 'Ouuups ...',
        text: props.t('err'),
      });
    }
  };

  const handleCancel = () => {
    resetForm();
  };

  const resetForm = () => {
    resetField('sub_activity_name');
    resetField('sub_activity_activity');
    setCreateModal(!CreateModal);
  };

  useEffect(() => {
    const getActivities = () => {
      httpClient.current?.get(`/api/activity/all`).then((response) => {
        setActivities(response.data);
      });
    };
    getActivities();
  }, [httpClient]);

  return (
    <>
      <Button outline color="success" onClick={CreateModalToggle}>
        {' '}
        {props.t('create_sub_activity')}
      </Button>
      <Modal isOpen={CreateModal} toggle={CreateModalToggle} centered>
        <ModalHeader toggle={CreateModalToggle}>{props.t('create_sub_activity')}</ModalHeader>
        <ModalBody>
          <Fragment>
            <Alert className="alert-dismissible" color="success dark" isOpen={Open} target="Alert">
              <strong>{props.t('great')}</strong>
              <Button className="close" color="default" id="Alert" onClick={Toggle}>
                <span>×</span>
              </Button>
            </Alert>
            {activities.length <= 0 ? (
              <div className="text-center">
                <Button outline color="danger" onClick={() => history.push('/settings/activity')}>
                  {props.t('msg_enter_activity')}
                </Button>
              </div>
            ) : spinner === true ? (
              <div className="loader-box">
                <div className="loader-3"></div>
              </div>
            ) : (
              <form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
                <FormGroup className="form-row">
                  <label htmlFor="sub_activity_name">{props.t('sub_activity_name')}</label>
                  <input
                    type="text"
                    className="form-control"
                    name="sub_activity_name"
                    id="sub_activity_name"
                    aria-invalid={errors.sub_activity_name ? 'true' : 'false'}
                    placeholder={props.t('enter_sub_activity_name')}
                    {...register('sub_activity_name', { required: true })}
                  />
                  <span>{errors.sub_activity_name && <p>{props.t('errors_champ')}</p>}</span>
                </FormGroup>
                <FormGroup className="form-row">
                  <label htmlFor={'sub_activity_activity'}>{props.t('charge_activity_name')}</label>
                  <select
                    name="sub_activity_activity"
                    id="sub_activity_activity"
                    className="form-control"
                    {...register('sub_activity_activity')}
                  >
                    {activities.map((activity, index) => (
                      <option id={activity.id} key={index} value={JSON.stringify(activity)}>
                        {activity.name}
                      </option>
                    ))}
                  </select>
                </FormGroup>

                <Button outline color="success" className="float-right" type="submit">
                  {props.t('save')}
                </Button>
                <Button className={styles['btn-cancel']} onClick={handleCancel}>
                  {props.t('cancel')}
                </Button>
              </form>
            )}
          </Fragment>
        </ModalBody>
      </Modal>
    </>
  );
};

export default translate(CreateSousActivity);
